import { render } from "./VJumpConfirm.vue?vue&type=template&id=89f7c736&ts=true"
import script from "./VJumpConfirm.vue?vue&type=script&lang=ts"
export * from "./VJumpConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__